import { render, staticRenderFns } from "./about_us.vue?vue&type=template&id=efefcfc2&scoped=true"
import script from "./about_us.vue?vue&type=script&lang=js"
export * from "./about_us.vue?vue&type=script&lang=js"
import style0 from "./about_us.vue?vue&type=style&index=0&id=efefcfc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efefcfc2",
  null
  
)

export default component.exports